module.exports = __webpack_public_path__ + "static/media/rel_analise_recebimentos.e07b2324.svg";